<script setup lang="ts">
import AppConfirmDialog from './components/base/AppConfirmDialog.vue';
import GuestPrompt from './components/guest/GuestPrompt.vue';
import PwaInstallBanner from './components/PwaInstallBanner.vue';
import TheSnackbar from './components/TheSnackbar.vue';
import { formatSeoTitle, normalizeSeoBaseURL } from '@/constants/seo';
import { useThemeStore } from '@/stores/theme';

const route = useRoute();
const config = useRuntimeConfig();
const theme = useThemeStore();
const canonicalBaseURL = normalizeSeoBaseURL(config.public.baseURL);

if (import.meta.client) useFirebase();

useHead(() => ({
  titleTemplate: (titleChunk?: string) => formatSeoTitle(titleChunk),
  htmlAttrs: {
    lang: 'en',
    'data-tradel-theme': theme.resolved,
    class: theme.isDark ? 'tradel-dark' : undefined,
  },
  meta: [
    { name: 'color-scheme', content: theme.resolved },
    { name: 'theme-color', content: theme.isDark ? '#191919' : '#ffffff' },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${canonicalBaseURL}${route.path}`,
    },
  ],
  script: [
    {
      key: 'gtm',
      innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PBHZMFJL');`,
    },
  ],
  noscript: [
    {
      key: 'gtm-noscript',
      innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PBHZMFJL" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
    },
  ],
}));
</script>

<template>
  <v-app>
    <VitePwaManifest />
    <ClientOnly>
      <PwaInstallBanner />
    </ClientOnly>
    <NuxtLoadingIndicator color="#313A68" :height="3" />
    <NuxtLayout />

    <TheSnackbar />
    <AppConfirmDialog />
    <GuestPrompt />
  </v-app>
</template>
